import React, { useState, useCallback, useMemo } from "react";
import Label from "lib/Label";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector } from "react-redux";

const MultiSelectCheckbox = (props) => {
  const {
    name,
    title,
    error,
    options,
    onChange,
    size,
    isEditable,
    validators,
    question,
    id,
    questionnaireId,
    content,
    riskProfile,
  } = props;

  const [selectedOptions, setSelectedOptions] = useState([]);
  const questionData = useSelector((state) => state.formData?.questionData);

  const errorClass = useMemo(() => (error?.length ? "error_outline" : ""), [error]);

  const handleCheckboxChange = useCallback(
    (option) => {
      setSelectedOptions((prevSelected) => {
        const isSelected = prevSelected.some((selected) => selected.optionId === option.id);
        const optionData = {
          label: option.label,
          optionId: option.id,
          score: Number(option.score),
        };
        const newSelectedOptions = isSelected
          ? prevSelected.filter((selected) => selected.optionId !== option.id)
          : [...prevSelected, optionData];

        const totalScore = newSelectedOptions.reduce((sum, selected) => sum + Math.max(selected.score, 0), 0);

        if (onChange) {
          const isChecked = !isSelected;
          onChange(id, option.label, question, isChecked, totalScore, questionnaireId, name, content);
        }

        return newSelectedOptions;
      });
    },
    [onChange, id, question, name, content, questionnaireId]
  );

  const isChecked = useCallback((option) => {
    return questionData?.some((item) => item?.answer?.includes(option.label));
  }, [questionData]);
  
  const IndirectEval = (item) => {
    return eval(item);
  };

  return (
    <div className={`card_container ${riskProfile ? "card_container_disabled" : errorClass}`}>
      <p>{title}</p>
      <Label className="question_label" label={question} validators={validators} />
      {content && (
        <div
          className="table table-responsive"
          dangerouslySetInnerHTML={{ __html: IndirectEval(content)  }}
        />
      )}
      {options?.map((option, i) => {
        const { id, label, checkbox_class } = option;
        const checkboxId = `${name}${id}`;

        return (
          <div
            key={checkboxId}
            className={`${checkbox_class || ""} ${size} border border-theme rounded-1 ${i < options.length - 1 ? "mb-2" : ""}`}
          >
            <div className={`checkbox me-0 ${errorClass}`}>
              <label className="checkbox_label d-flex align-items-center gap-2 w-100 p-2 ps-0" htmlFor={checkboxId}>
                <input
                  className="accent-theme ms-2 h-15px w-15px"
                  id={checkboxId}
                  type="checkbox"
                  name={name}
                  onChange={() => handleCheckboxChange(option)}
                  disabled={!isEditable}
                  checked={isChecked(option)}
                />
                <span className="mt-1 fs-15px">{label}</span>
              </label>
            </div>
          </div>
        );
      })}
      {error?.length > 0 && <ErrorMessage error={error} />}
    </div>
  );
};

export default MultiSelectCheckbox;
